export const defaultShippingContact = {
  firstname: "",
  lastname: "",
  telephone: "",
};
